import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
	CardFooter,
} from '@/components/ui/card';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormMessage,
} from '@/components/ui/form';
import {
	InputOTP,
	InputOTPGroup,
	InputOTPSlot,
} from '@/components/ui/input-otp';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ChevronLeft } from 'lucide-react';
import useValidate from '../hooks/useValidate';

const Validate = () => {
	const { t } = useTranslation();
	const { state } = useLocation();
	const navigate = useNavigate();

	const { validate, validateLoading } = useValidate();

	const email = state?.email;
	const type = state?.type;

	useEffect(() => {
		if (!email || !type) {
			navigate('/');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const FormSchema = z.object({
		code: z.string().min(5, {
			message: t('validate.error.invalid'),
		}),
	});

	const form = useForm<z.infer<typeof FormSchema>>({
		resolver: zodResolver(FormSchema),
		defaultValues: {
			code: '',
		},
	});

	function handleSubmit(values: z.infer<typeof FormSchema>) {
		const valid = form.trigger();

		if (!valid) return;

		validate(
			{ email, code: values.code, type },
			{
				onSuccess(data) {
					if (data?.status !== 200) {
						form.setError('code', {
							message: t('validate.error.invalid'),
						});
					} else {
						navigate('/validated');
					}
				},
			}
		);
	}

	return (
		<>
			<Card className="mx-auto -mt-9 max-w-sm self-center">
				<Link to="/register" className="-mt-10 flex p-2 pl-0">
					<ChevronLeft />
					{t('back')}
				</Link>
				<CardHeader>
					<CardTitle className="text-xl">
						{t('validate.title')}
					</CardTitle>
				</CardHeader>
				<CardContent>
					<Form {...form}>
						<form
							onSubmit={form.handleSubmit(handleSubmit)}
							className="flex w-full justify-center space-y-6"
						>
							<FormField
								control={form.control}
								name="code"
								render={({ field }) => (
									<FormItem>
										<FormControl>
											<InputOTP
												// disabled={true}
												maxLength={5}
												onComplete={() =>
													handleSubmit(
														form.getValues()
													)
												}
												disabled={validateLoading}
												{...field}
											>
												<InputOTPGroup>
													<InputOTPSlot
														className="h-14 w-14 text-lg"
														index={0}
													/>
													<InputOTPSlot
														className="h-14 w-14 text-lg"
														index={1}
													/>
													<InputOTPSlot
														className="h-14 w-14 text-lg"
														index={2}
													/>
													<InputOTPSlot
														className="h-14 w-14 text-lg"
														index={3}
													/>
													<InputOTPSlot
														className="h-14 w-14 text-lg"
														index={4}
													/>
												</InputOTPGroup>
											</InputOTP>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
						</form>
					</Form>
				</CardContent>
				<CardFooter>
					<CardDescription>
						{t('validate.description')}
					</CardDescription>
				</CardFooter>
			</Card>
		</>
	);
};

export default Validate;
